module.exports = __webpack_public_path__ + "static/assets/a700ef6a9a7d90948cd0398d3de176b8.png";